import ParticipantsList from './participant-list-container'

export default ParticipantsList
